<template>
  <main>
    <div class="breadcrumb">
      <div class="container">
        <ul>
          <li><router-link to="/">HARUMIFLAG</router-link></li>
          <li><router-link to="/about/design">{{aboutDesignList.acf?.page_title}}</router-link></li>
        </ul>
      </div>
    </div>
    <div class="access">
      <div class="container">
          <h2 class="page--title">ABOUT<span>HARUMI FLAGについて</span></h2>
          <AboutMenu :aboutMenuChild="aboutMenu" />
          <!-- Tab content -->
          <div class="tab-content" 
          :style="[aboutDesignList.acf?.medium_title ||  aboutDesignList.acf?.medium_subtitle || aboutDesignList.acf?.medium_text_1 || aboutDesignList.acf?.medium_text_2 ||
              aboutDesignList.acf?.small_title_1 || aboutDesignList.acf?.small_image_1 || aboutDesignList.acf?.small_text_1 ||
              aboutDesignList.acf?.small_title_2 || aboutDesignList.acf?.small_image_2 || aboutDesignList.acf?.small_text_2 ||
              aboutDesignList.acf?.small_title_3 || aboutDesignList.acf?.small_image_3 || aboutDesignList.acf?.small_text_3 ||
              aboutDesignList.acf?.small_title_4 || aboutDesignList.acf?.small_image_4 || aboutDesignList.acf?.small_text_4 ||
              aboutDesignList.acf?.small_title_5 || aboutDesignList.acf?.small_image_5 || aboutDesignList.acf?.small_text_5 ||
              aboutDesignList.acf?.small_title_6 || aboutDesignList.acf?.small_image_6 || aboutDesignList.acf?.small_text_6 ||
              aboutDesignList.acf?.small_title_7 || aboutDesignList.acf?.small_image_7 || aboutDesignList.acf?.small_text_7 ||
              aboutDesignList.acf?.small_title_8 || aboutDesignList.acf?.small_image_8 || aboutDesignList.acf?.small_text_8 ||
              aboutDesignList.acf?.small_title_9 || aboutDesignList.acf?.small_image_9 || aboutDesignList.acf?.small_text_9 ||
              aboutDesignList.acf?.small_title_10 || aboutDesignList.acf?.small_image_10 || aboutDesignList.acf?.small_text_10
        ] ? {'padding-bottom': '100px'} : {'padding-bottom': '0'}">
            <h2 class="access__title" style="text-align: center;" v-if="aboutDesignList.acf?.page_title && !isLoading">{{ aboutDesignList.acf?.page_title }}</h2>
            <div :id="aboutDesignList.acf?.large_title_1" class="access__content content--1 content-custom current" v-if="aboutDesignList.acf?.large_title_1 || aboutDesignList.acf?.large_text_1 || aboutDesignList.acf?.large_image_1">
              <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 35px;">
                <PuSkeleton style="height: 30px;" :count="1"/>
              </div>
              <div class="img_holder">
                <img
                  v-if="aboutDesignList.acf?.large_image_1 && !isLoading"
                  :src="$func.formatUrl(aboutDesignList.acf?.large_image_1)" 
                  :alt="aboutDesignList.acf?.large_title_1"
                />
              </div>
              <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
                <PuSkeleton style="height: 500px;" :count="1"/>
              </div>
              <h2 v-if="aboutDesignList.acf?.large_title_1 && !isLoading">{{ aboutDesignList.acf?.large_title_1 }}</h2>
              <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 35px;">
                <PuSkeleton style="height: 30px;" :count="1"/>
              </div>
              <p v-if="aboutDesignList.acf?.large_text_1 && !isLoading" v-html="aboutDesignList.acf?.large_text_1"></p>
              <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
                <PuSkeleton style="height: 30px;" :count="1"/>
              </div>
              <div class="link_holder" v-if="aboutDesignList.acf?.display_name_1">
                <a :href="aboutDesignList.acf?.url_1" :target="aboutDesignList.acf?.operation_at_transition_1 === '同一ウィンドウで表示' ? '_self' : '_blank'">
                  <span>{{ aboutDesignList.acf?.display_name_1 }}</span>
                  <img
                    class="icolink"
                    src="@/assets/img/access/svgfile/ico_link_white.svg"
                    alt=""
                  />
                </a>
              </div>
            </div>

            <div :id="aboutDesignList.acf?.large_title_2" class="access__content content--1 current" v-if="aboutDesignList.acf?.large_title_2 || aboutDesignList.acf?.large_text_2 || aboutDesignList.acf?.large_image_2">
              <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 35px;">
                <PuSkeleton style="height: 30px;" :count="1"/>
              </div>
              <div class="img_holder">
                <img
                  v-if="aboutDesignList.acf?.large_image_2 && !isLoading"
                  :src="$func.formatUrl(aboutDesignList.acf?.large_image_2)" 
                  :alt="aboutDesignList.acf?.large_title_2"
                />
              </div>
              <h2 v-if="aboutDesignList.acf?.large_title_2 && !isLoading">{{ aboutDesignList.acf?.large_title_2 }}</h2>
              <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
                <PuSkeleton style="height: 500px;" :count="1"/>
              </div>
              <p v-if="aboutDesignList.acf?.large_text_2 && !isLoading" v-html="aboutDesignList.acf?.large_text_2"></p>
              <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
                <PuSkeleton style="height: 30px;" :count="1"/>
              </div>
              <div class="link_holder" v-if="aboutDesignList.acf?.display_name_2">
                <a :href="aboutDesignList.acf?.url_2" :target="aboutDesignList.acf?.operation_at_transition_2 === '同一ウィンドウで表示' ? '_self' : '_blank'">
                  <span>{{ aboutDesignList.acf?.display_name_2 }}</span>
                  <img
                    class="icolink"
                    src="@/assets/img/access/svgfile/ico_link_white.svg"
                    alt=""
                  />
                </a>
              </div>
            </div>

            <div :id="aboutDesignList.acf?.large_title_3" class="access__content content--1 current" v-if="aboutDesignList.acf?.large_title_3 || aboutDesignList.acf?.large_text_3 || aboutDesignList.acf?.large_image_3">
              <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 35px;">
                <PuSkeleton style="height: 30px;" :count="1"/>
              </div>
              <div class="img_holder">
                <img
                  v-if="aboutDesignList.acf?.large_image_3 && !isLoading"
                  :src="$func.formatUrl(aboutDesignList.acf?.large_image_3)" 
                  :alt="aboutDesignList.acf?.large_title_3"
                />
              </div>
              <h2 v-if="aboutDesignList.acf?.large_title_3 && !isLoading">{{ aboutDesignList.acf?.large_title_3 }}</h2>
              <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
                <PuSkeleton style="height: 500px;" :count="1"/>
              </div>
              <p v-if="aboutDesignList.acf?.large_text_3 && !isLoading" v-html="aboutDesignList.acf?.large_text_3"></p>
              <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
                <PuSkeleton style="height: 30px;" :count="1"/>
              </div>
              <div class="link_holder" v-if="aboutDesignList.acf?.display_name_3">
                <a :href="aboutDesignList.acf?.url_3" :target="aboutDesignList.acf?.operation_at_transition_3 === '同一ウィンドウで表示' ? '_self' : '_blank'">
                  <span>{{ aboutDesignList.acf?.display_name_3 }}</span>
                  <img
                    class="icolink"
                    src="@/assets/img/access/svgfile/ico_link_white.svg"
                    alt=""
                  />
                </a>
              </div>
            </div>

            <div :id="aboutDesignList.acf?.large_title_4" class="access__content content--1 current" v-if="aboutDesignList.acf?.large_title_4 || aboutDesignList.acf?.large_text_4 || aboutDesignList.acf?.large_image_4">
              <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 35px;">
                <PuSkeleton style="height: 30px;" :count="1"/>
              </div>
              <div class="img_holder">
                <img
                  v-if="aboutDesignList.acf?.large_image_4 && !isLoading"
                  :src="$func.formatUrl(aboutDesignList.acf?.large_image_4)" 
                  :alt="aboutDesignList.acf?.large_title_4"
                />
              </div>
              <h2 v-if="aboutDesignList.acf?.large_title_4 && !isLoading">{{ aboutDesignList.acf?.large_title_4 }}</h2>
              <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
                <PuSkeleton style="height: 500px;" :count="1"/>
              </div>
              <p v-if="aboutDesignList.acf?.large_text_4 && !isLoading" v-html="aboutDesignList.acf?.large_text_4"></p>
              <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
                <PuSkeleton style="height: 30px;" :count="1"/>
              </div>
              <div class="link_holder" v-if="aboutDesignList.acf?.display_name_4">
                <a :href="aboutDesignList.acf?.url_4" :target="aboutDesignList.acf?.operation_at_transition_4 === '同一ウィンドウで表示' ? '_self' : '_blank'">
                  <span>{{ aboutDesignList.acf?.display_name_4 }}</span>
                  <img
                    class="icolink"
                    src="@/assets/img/access/svgfile/ico_link_white.svg"
                    alt=""
                  />
                </a>
              </div>
            </div>

            <div :id="aboutDesignList.acf?.large_title_5" class="access__content content--1 current" v-if="aboutDesignList.acf?.large_title_5 || aboutDesignList.acf?.large_text_5 || aboutDesignList.acf?.large_image_5">
              <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 35px;">
                <PuSkeleton style="height: 30px;" :count="1"/>
              </div>
              <div class="img_holder">
                <img
                  v-if="aboutDesignList.acf?.large_image_5 && !isLoading"
                  :src="$func.formatUrl(aboutDesignList.acf?.large_image_5)" 
                  :alt="aboutDesignList.acf?.large_title_5"
                />
              </div>
              <h2 v-if="aboutDesignList.acf?.large_title_5 && !isLoading">{{ aboutDesignList.acf?.large_title_5 }}</h2>
              <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
                <PuSkeleton style="height: 500px;" :count="1"/>
              </div>
              <p v-if="aboutDesignList.acf?.large_text_5 && !isLoading" v-html="aboutDesignList.acf?.large_text_5"></p>
              <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
                <PuSkeleton style="height: 30px;" :count="1"/>
              </div>
              <div class="link_holder" v-if="aboutDesignList.acf?.display_name_5">
                <a :href="aboutDesignList.acf?.url_5" :target="aboutDesignList.acf?.operation_at_transition_5 === '同一ウィンドウで表示' ? '_self' : '_blank'">
                  <span>{{ aboutDesignList.acf?.display_name_5 }}</span>
                  <img
                    class="icolink"
                    src="@/assets/img/access/svgfile/ico_link_white.svg"
                    alt=""
                  />
                </a>
              </div>
            </div>

            <div :id="aboutDesignList.acf?.large_title_6" class="access__content content--1 current" v-if="aboutDesignList.acf?.large_title_6 || aboutDesignList.acf?.large_text_6 || aboutDesignList.acf?.large_image_6">
              <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 35px;">
                <PuSkeleton style="height: 30px;" :count="1"/>
              </div>
              <div class="img_holder">
                <img
                  v-if="aboutDesignList.acf?.large_image_6 && !isLoading"
                  :src="$func.formatUrl(aboutDesignList.acf?.large_image_6)" 
                  :alt="aboutDesignList.acf?.large_title_6"
                />
              </div>
              <h2 v-if="aboutDesignList.acf?.large_title_6 && !isLoading">{{ aboutDesignList.acf?.large_title_6 }}</h2>
              <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
                <PuSkeleton style="height: 500px;" :count="1"/>
              </div>
              <p v-if="aboutDesignList.acf?.large_text_6 && !isLoading" v-html="aboutDesignList.acf?.large_text_6"></p>
              <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
                <PuSkeleton style="height: 30px;" :count="1"/>
              </div>
              <div class="link_holder" v-if="aboutDesignList.acf?.display_name_6">
                <a :href="aboutDesignList.acf?.url_6" :target="aboutDesignList.acf?.operation_at_transition_6 === '同一ウィンドウで表示' ? '_self' : '_blank'">
                  <span>{{ aboutDesignList.acf?.display_name_6 }}</span>
                  <img
                    class="icolink"
                    src="@/assets/img/access/svgfile/ico_link_white.svg"
                    alt=""
                  />
                </a>
              </div>
            </div>

            <div :id="aboutDesignList.acf?.large_title_7" class="access__content content--1 current" v-if="aboutDesignList.acf?.large_title_7 || aboutDesignList.acf?.large_text_7 || aboutDesignList.acf?.large_image_7">
              <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 35px;">
                <PuSkeleton style="height: 30px;" :count="1"/>
              </div>
              <div class="img_holder">
                <img
                  v-if="aboutDesignList.acf?.large_image_7 && !isLoading"
                  :src="$func.formatUrl(aboutDesignList.acf?.large_image_7)" 
                  :alt="aboutDesignList.acf?.large_title_7"
                />
              </div>
              <h2 v-if="aboutDesignList.acf?.large_title_7 && !isLoading">{{ aboutDesignList.acf?.large_title_7 }}</h2>
              <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
                <PuSkeleton style="height: 500px;" :count="1"/>
              </div>
              <p v-if="aboutDesignList.acf?.large_text_7 && !isLoading" v-html="aboutDesignList.acf?.large_text_7"></p>
              <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
                <PuSkeleton style="height: 30px;" :count="1"/>
              </div>
              <div class="link_holder" v-if="aboutDesignList.acf?.display_name_7">
                <a :href="aboutDesignList.acf?.url_7" :target="aboutDesignList.acf?.operation_at_transition_7 === '同一ウィンドウで表示' ? '_self' : '_blank'">
                  <span>{{ aboutDesignList.acf?.display_name_7 }}</span>
                  <img
                    class="icolink"
                    src="@/assets/img/access/svgfile/ico_link_white.svg"
                    alt=""
                  />
                </a>
              </div>
            </div>

            <div :id="aboutDesignList.acf?.large_title_8" class="access__content content--1 current" v-if="aboutDesignList.acf?.large_title_8 || aboutDesignList.acf?.large_text_8 || aboutDesignList.acf?.large_image_8">
              <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 35px;">
                <PuSkeleton style="height: 30px;" :count="1"/>
              </div>
              <div class="img_holder">
                <img
                  v-if="aboutDesignList.acf?.large_image_8 && !isLoading"
                  :src="$func.formatUrl(aboutDesignList.acf?.large_image_8)" 
                  :alt="aboutDesignList.acf?.large_title_8"
                />
              </div>
              <h2 v-if="aboutDesignList.acf?.large_title_8 && !isLoading">{{ aboutDesignList.acf?.large_title_8 }}</h2>
              <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
                <PuSkeleton style="height: 500px;" :count="1"/>
              </div>
              <p v-if="aboutDesignList.acf?.large_text_8 && !isLoading" v-html="aboutDesignList.acf?.large_text_8"></p>
              <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
                <PuSkeleton style="height: 30px;" :count="1"/>
              </div>
              <div class="link_holder" v-if="aboutDesignList.acf?.display_name_8">
                <a :href="aboutDesignList.acf?.url_8" :target="aboutDesignList.acf?.operation_at_transition_8 === '同一ウィンドウで表示' ? '_self' : '_blank'">
                  <span>{{ aboutDesignList.acf?.display_name_8 }}</span>
                  <img
                    class="icolink"
                    src="@/assets/img/access/svgfile/ico_link_white.svg"
                    alt=""
                  />
                </a>
              </div>
            </div>

            <div :id="aboutDesignList.acf?.large_title_9" class="access__content content--1 current" v-if="aboutDesignList.acf?.large_title_9 || aboutDesignList.acf?.large_text_9 || aboutDesignList.acf?.large_image_9">
              <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 35px;">
                <PuSkeleton style="height: 30px;" :count="1"/>
              </div>
              <div class="img_holder">
                <img
                  v-if="aboutDesignList.acf?.large_image_9 && !isLoading"
                  :src="$func.formatUrl(aboutDesignList.acf?.large_image_9)" 
                  :alt="aboutDesignList.acf?.large_title_9"
                />
              </div>
              <h2 v-if="aboutDesignList.acf?.large_title_9 && !isLoading">{{ aboutDesignList.acf?.large_title_9 }}</h2>
              <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
                <PuSkeleton style="height: 500px;" :count="1"/>
              </div>
              <p v-if="aboutDesignList.acf?.large_text_9 && !isLoading" v-html="aboutDesignList.acf?.large_text_9"></p>
              <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
                <PuSkeleton style="height: 30px;" :count="1"/>
              </div>
              <div class="link_holder" v-if="aboutDesignList.acf?.display_name_9">
                <a :href="aboutDesignList.acf?.url_9" :target="aboutDesignList.acf?.operation_at_transition_9 === '同一ウィンドウで表示' ? '_self' : '_blank'">
                  <span>{{ aboutDesignList.acf?.display_name_9 }}</span>
                  <img
                    class="icolink"
                    src="@/assets/img/access/svgfile/ico_link_white.svg"
                    alt=""
                  />
                </a>
              </div>
            </div>

            <div :id="aboutDesignList.acf?.large_title_10" class="access__content content--1 current" v-if="aboutDesignList.acf?.large_title_10 || aboutDesignList.acf?.large_text_10 || aboutDesignList.acf?.large_image_10">
              <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 35px;">
                <PuSkeleton style="height: 30px;" :count="1"/>
              </div>
              <div class="img_holder">
                <img
                  v-if="aboutDesignList.acf?.large_image_10 && !isLoading"
                  :src="$func.formatUrl(aboutDesignList.acf?.large_image_10)" 
                  :alt="aboutDesignList.acf?.large_title_10"
                />
              </div>
              <h2 v-if="aboutDesignList.acf?.large_title_10 && !isLoading">{{ aboutDesignList.acf?.large_title_10 }}</h2>
              <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
                <PuSkeleton style="height: 500px;" :count="1"/>
              </div>
              <p v-if="aboutDesignList.acf?.large_text_10 && !isLoading" v-html="aboutDesignList.acf?.large_text_10"></p>
              <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
                <PuSkeleton style="height: 30px;" :count="1"/>
              </div>
              <div class="link_holder" v-if="aboutDesignList.acf?.display_name_10">
                <a :href="aboutDesignList.acf?.url_10" :target="aboutDesignList.acf?.operation_at_transition_10 === '同一ウィンドウで表示' ? '_self' : '_blank'">
                  <span>{{ aboutDesignList.acf?.display_name_10 }}</span>
                  <img
                    class="icolink"
                    src="@/assets/img/access/svgfile/ico_link_white.svg"
                    alt=""
                  />
                </a>
              </div>
            </div>

            <div class="cont-bottom"
              v-if="aboutDesignList.acf?.medium_title ||  aboutDesignList.acf?.medium_subtitle || aboutDesignList.acf?.medium_text_1 || aboutDesignList.acf?.medium_text_2 ||
              aboutDesignList.acf?.small_title_1 || aboutDesignList.acf?.small_image_1 || aboutDesignList.acf?.small_text_1 ||
              aboutDesignList.acf?.small_title_2 || aboutDesignList.acf?.small_image_2 || aboutDesignList.acf?.small_text_2 ||
              aboutDesignList.acf?.small_title_3 || aboutDesignList.acf?.small_image_3 || aboutDesignList.acf?.small_text_3 ||
              aboutDesignList.acf?.small_title_4 || aboutDesignList.acf?.small_image_4 || aboutDesignList.acf?.small_text_4 ||
              aboutDesignList.acf?.small_title_5 || aboutDesignList.acf?.small_image_5 || aboutDesignList.acf?.small_text_5 ||
              aboutDesignList.acf?.small_title_6 || aboutDesignList.acf?.small_image_6 || aboutDesignList.acf?.small_text_6 ||
              aboutDesignList.acf?.small_title_7 || aboutDesignList.acf?.small_image_7 || aboutDesignList.acf?.small_text_7 ||
              aboutDesignList.acf?.small_title_8 || aboutDesignList.acf?.small_image_8 || aboutDesignList.acf?.small_text_8 ||
              aboutDesignList.acf?.small_title_9 || aboutDesignList.acf?.small_image_9 || aboutDesignList.acf?.small_text_9 ||
              aboutDesignList.acf?.small_title_10 || aboutDesignList.acf?.small_image_10 || aboutDesignList.acf?.small_text_10
            ">
              <h2 v-if="aboutDesignList.acf?.medium_title || aboutDesignList.acf?.medium_subtitle">
                {{ aboutDesignList.acf?.medium_title}}<span>{{ aboutDesignList.acf?.medium_subtitle }}</span>
              </h2>
              <p v-if="aboutDesignList.acf?.medium_text_1" v-html="aboutDesignList.acf?.medium_text_1"></p>
              <p v-if="aboutDesignList.acf?.medium_text_2" v-html="aboutDesignList.acf?.medium_text_2"></p>
              <div class="cont__list">
                <div class="cont__list__child" v-if="aboutDesignList.acf?.small_title_1 || aboutDesignList.acf?.small_image_1 || aboutDesignList.acf?.small_text_1">
                  <div class="cont__list__child--item">
                    <div class="wrap-img">
                      <img 
                        v-if="aboutDesignList.acf?.small_image_1"
                        :src="$func.formatUrl(aboutDesignList.acf?.small_image_1)" 
                        :alt="aboutDesignList.acf?.small_title_1" />
                    </div>
                  </div>
                  <div class="cont__list__child--item">
                    <h3 v-if="aboutDesignList.acf?.small_title_1">{{ aboutDesignList.acf?.small_title_1 }}</h3>
                    <p v-if="aboutDesignList.acf?.small_text_1" v-html="aboutDesignList.acf?.small_text_1"></p>
                  </div>
                </div>

                <div class="cont__list__child"  v-if="aboutDesignList.acf?.small_title_2 || aboutDesignList.acf?.small_image_2 || aboutDesignList.acf?.small_text_2">
                  <div class="cont__list__child--item">
                    <div class="wrap-img">
                      <img 
                        v-if="aboutDesignList.acf?.small_image_2"
                        :src="$func.formatUrl(aboutDesignList.acf?.small_image_2)" 
                        :alt="aboutDesignList.acf?.small_title_2" />
                    </div>
                  </div>
                  <div class="cont__list__child--item">
                    <h3 v-if="aboutDesignList.acf?.small_title_2">{{ aboutDesignList.acf?.small_title_2 }}</h3>
                    <p v-if="aboutDesignList.acf?.small_text_2" v-html="aboutDesignList.acf?.small_text_2"></p>
                  </div>
                </div>

                <div class="cont__list__child"  v-if="aboutDesignList.acf?.small_title_3 || aboutDesignList.acf?.small_image_3 || aboutDesignList.acf?.small_text_3">
                  <div class="cont__list__child--item">
                    <div class="wrap-img">
                      <img 
                        v-if="aboutDesignList.acf?.small_image_3"
                        :src="$func.formatUrl(aboutDesignList.acf?.small_image_3)" 
                        :alt="aboutDesignList.acf?.small_title_3" />
                    </div>
                  </div>
                  <div class="cont__list__child--item">
                    <h3 v-if="aboutDesignList.acf?.small_title_3">{{ aboutDesignList.acf?.small_title_3 }}</h3>
                    <p v-if="aboutDesignList.acf?.small_text_3" v-html="aboutDesignList.acf?.small_text_3"></p>
                  </div>
                </div>

                <div class="cont__list__child"  v-if="aboutDesignList.acf?.small_title_4 || aboutDesignList.acf?.small_image_4 || aboutDesignList.acf?.small_text_4">
                  <div class="cont__list__child--item">
                    <div class="wrap-img">
                      <img 
                        v-if="aboutDesignList.acf?.small_image_4"
                        :src="$func.formatUrl(aboutDesignList.acf?.small_image_4)" 
                        :alt="aboutDesignList.acf?.small_title_4" />
                    </div>
                  </div>
                  <div class="cont__list__child--item">
                    <h3 v-if="aboutDesignList.acf?.small_title_4">{{ aboutDesignList.acf?.small_title_4 }}</h3>
                    <p v-if="aboutDesignList.acf?.small_text_4" v-html="aboutDesignList.acf?.small_text_4"></p>
                  </div>
                </div>

                <div class="cont__list__child"  v-if="aboutDesignList.acf?.small_title_5 || aboutDesignList.acf?.small_image_5 || aboutDesignList.acf?.small_text_5">
                  <div class="cont__list__child--item">
                    <div class="wrap-img">
                      <img 
                        v-if="aboutDesignList.acf?.small_image_5"
                        :src="$func.formatUrl(aboutDesignList.acf?.small_image_5)" 
                        :alt="aboutDesignList.acf?.small_title_5" />
                    </div>
                  </div>
                  <div class="cont__list__child--item">
                    <h3 v-if="aboutDesignList.acf?.small_title_5">{{ aboutDesignList.acf?.small_title_5 }}</h3>
                    <p v-if="aboutDesignList.acf?.small_text_5" v-html="aboutDesignList.acf?.small_text_5"></p>
                  </div>
                </div>

                <div class="cont__list__child"  v-if="aboutDesignList.acf?.small_title_6 || aboutDesignList.acf?.small_image_6 || aboutDesignList.acf?.small_text_6">
                  <div class="cont__list__child--item">
                    <div class="wrap-img">
                      <img 
                        v-if="aboutDesignList.acf?.small_image_6"
                        :src="$func.formatUrl(aboutDesignList.acf?.small_image_6)" 
                        :alt="aboutDesignList.acf?.small_title_6" />
                    </div>
                  </div>
                  <div class="cont__list__child--item">
                    <h3 v-if="aboutDesignList.acf?.small_title_6">{{ aboutDesignList.acf?.small_title_6 }}</h3>
                    <p v-if="aboutDesignList.acf?.small_text_6" v-html="aboutDesignList.acf?.small_text_6"></p>
                  </div>
                </div>

                <div class="cont__list__child"  v-if="aboutDesignList.acf?.small_title_7 || aboutDesignList.acf?.small_image_7 || aboutDesignList.acf?.small_text_7">
                  <div class="cont__list__child--item">
                    <div class="wrap-img">
                      <img 
                        v-if="aboutDesignList.acf?.small_image_7"
                        :src="$func.formatUrl(aboutDesignList.acf?.small_image_7)" 
                        :alt="aboutDesignList.acf?.small_title_7" />
                    </div>
                  </div>
                  <div class="cont__list__child--item">
                    <h3 v-if="aboutDesignList.acf?.small_title_7">{{ aboutDesignList.acf?.small_title_7 }}</h3>
                    <p v-if="aboutDesignList.acf?.small_text_7" v-html="aboutDesignList.acf?.small_text_7"></p>
                  </div>
                </div>

                <div class="cont__list__child"  v-if="aboutDesignList.acf?.small_title_8 || aboutDesignList.acf?.small_image_8 || aboutDesignList.acf?.small_text_8">
                  <div class="cont__list__child--item">
                    <div class="wrap-img">
                      <img 
                        v-if="aboutDesignList.acf?.small_image_8"
                        :src="$func.formatUrl(aboutDesignList.acf?.small_image_8)" 
                        :alt="aboutDesignList.acf?.small_title_8" />
                    </div>
                  </div>
                  <div class="cont__list__child--item">
                    <h3 v-if="aboutDesignList.acf?.small_title_8">{{ aboutDesignList.acf?.small_title_8 }}</h3>
                    <p v-if="aboutDesignList.acf?.small_text_8" v-html="aboutDesignList.acf?.small_text_8"></p>
                  </div>
                </div>

                <div class="cont__list__child"  v-if="aboutDesignList.acf?.small_title_9 || aboutDesignList.acf?.small_image_9 || aboutDesignList.acf?.small_text_9">
                  <div class="cont__list__child--item">
                    <div class="wrap-img">
                      <img 
                        v-if="aboutDesignList.acf?.small_image_9"
                        :src="$func.formatUrl(aboutDesignList.acf?.small_image_9)" 
                        :alt="aboutDesignList.acf?.small_title_9" />
                    </div>
                  </div>
                  <div class="cont__list__child--item">
                    <h3 v-if="aboutDesignList.acf?.small_title_9">{{ aboutDesignList.acf?.small_title_9 }}</h3>
                    <p v-if="aboutDesignList.acf?.small_text_9" v-html="aboutDesignList.acf?.small_text_9"></p>
                  </div>
                </div>

                <div class="cont__list__child"  v-if="aboutDesignList.acf?.small_title_10 || aboutDesignList.acf?.small_image_10 || aboutDesignList.acf?.small_text_10">
                  <div class="cont__list__child--item">
                    <div class="wrap-img">
                      <img 
                        v-if="aboutDesignList.acf?.small_image_10"
                        :src="$func.formatUrl(aboutDesignList.acf?.small_image_10)" 
                        :alt="aboutDesignList.acf?.small_title_10" />
                    </div>
                  </div>
                  <div class="cont__list__child--item">
                    <h3 v-if="aboutDesignList.acf?.small_title_10">{{ aboutDesignList.acf?.small_title_10 }}</h3>
                    <p v-if="aboutDesignList.acf?.small_text_10" v-html="aboutDesignList.acf?.small_text_10"></p>
                  </div>
                </div>

              </div>
            </div>

          </div>
      </div>
    </div>
  </main>
</template>

<script>
import CONSTANT from "@/constant";
import { getUrl, metaData } from '@/utils/helper';

export default {
  name: "Design",
  components: {
    AboutMenu: () => import("@/components/common/AboutMenu.vue"),
  },
  data() {
    return {
      aboutMenu: CONSTANT.dataAboutMenu,
      aboutDesignList: {},
      isLoading: true,
    };
  },
  computed: {},
  created() {
    this.isLoading = true;
 
    getUrl(`/about/${process.env.VUE_APP_ID_DESIGN}`)
      .then((response) => {
        this.aboutDesignList = response.data;
        
        metaData(
          `${this.aboutDesignList.acf?.page_title ? this.aboutDesignList.acf?.page_title : '地域全体のデザインに一体感のある個性的な街'} | HARUMIFLAGタウンポータル`,
          '中央区晴海・HARUMIFLAGの地域全体のデザインに一体感のある個性的な街のご紹介ページです。',
          'HARUMIFLAGタウンポータル',
          'article'
        )
        this.isLoading = false;
      })
      .catch((e) => {
        console.log(e);
        this.$router.push('/timeout')
      });
  },
};
</script>